


import { Routes, RouterModule } from '@angular/router';
import { ColumnDetailComponent } from './columndetail.component';

const routes: Routes = [
    {
        path: '',
        component: ColumnDetailComponent
    },
];

export const ColumnDetailRoutes = RouterModule.forChild(routes);
